/* eslint-disable @typescript-eslint/camelcase */
import React, { FC } from 'react'
import { Waypoint } from 'react-waypoint'

interface Props {
  eventLabel: 'contentBottom' | 'pageBottom'
}

/**
 * Scroll tracking component, currently just for the footer.
 */
export const ScrollTracking: FC<Props> = ({ eventLabel }) => (
  <Waypoint
    scrollableAncestor={window}
    onEnter={({ previousPosition }) => {
      if (previousPosition === Waypoint.below) {
        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({
          event: 'Interactions',
          event_action: 'vertical-scroll',
          event_label: eventLabel
        })
      }
    }}
  />
)
